const HeaderShareIcon = () => {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_2273_7374)'>
        <path d='M18.75 16.75C17.9583 16.75 17.25 17.0625 16.7083 17.5521L9.28125 13.2292C9.33333 12.9896 9.375 12.75 9.375 12.5C9.375 12.25 9.33333 12.0105 9.28125 11.7709L16.625 7.48962C17.1875 8.01046 17.9271 8.33337 18.75 8.33337C20.4792 8.33337 21.875 6.93754 21.875 5.20837C21.875 3.47921 20.4792 2.08337 18.75 2.08337C17.0208 2.08337 15.625 3.47921 15.625 5.20837C15.625 5.45837 15.6667 5.69796 15.7188 5.93754L8.375 10.2188C7.8125 9.69796 7.07292 9.37504 6.25 9.37504C4.52083 9.37504 3.125 10.7709 3.125 12.5C3.125 14.2292 4.52083 15.625 6.25 15.625C7.07292 15.625 7.8125 15.3021 8.375 14.7813L15.7917 19.1146C15.7396 19.3334 15.7083 19.5625 15.7083 19.7917C15.7083 21.4688 17.0729 22.8334 18.75 22.8334C20.4271 22.8334 21.7917 21.4688 21.7917 19.7917C21.7917 18.1146 20.4271 16.75 18.75 16.75ZM18.75 4.16671C19.3229 4.16671 19.7917 4.63546 19.7917 5.20837C19.7917 5.78129 19.3229 6.25004 18.75 6.25004C18.1771 6.25004 17.7083 5.78129 17.7083 5.20837C17.7083 4.63546 18.1771 4.16671 18.75 4.16671ZM6.25 13.5417C5.67708 13.5417 5.20833 13.073 5.20833 12.5C5.20833 11.9271 5.67708 11.4584 6.25 11.4584C6.82292 11.4584 7.29167 11.9271 7.29167 12.5C7.29167 13.073 6.82292 13.5417 6.25 13.5417ZM18.75 20.8542C18.1771 20.8542 17.7083 20.3855 17.7083 19.8125C17.7083 19.2396 18.1771 18.7709 18.75 18.7709C19.3229 18.7709 19.7917 19.2396 19.7917 19.8125C19.7917 20.3855 19.3229 20.8542 18.75 20.8542Z' />
      </g>
      <defs>
        <clipPath id='clip0_2273_7374'>
          <rect width='25' height='25' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default HeaderShareIcon
